















































































































































import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import ActionBar from '@/components/action-bar/action-bar.vue';
import ProjectLoader from '@/modules/dap/components/project-loader/project-loader.vue';
import DapProjectEmptyPage from '@/modules/dap/pages/dap-project-empty/dap-project-empty.page.vue';
import WizardProgress from '@/modules/dap/components/wizard-progress/wizard-progress.vue';

import { DapType } from '@/modules/dap/enums';
import { Size, PageContextName } from '@/enums';
import { IProject } from '@/modules/dap/interfaces';
import { dateService, httpService, stringService, traceLogAccess  } from '@/services';

import { CONFIG } from '@/config';
import { DAP_ROUTES } from '@/modules/dap/router';
import { GET_LOADING } from '@/store/types';

@Component({
  subscriptions() {
    return {
      searchValue$: this.$watchAsObservable('searchInput').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    ProjectLoader,
    WizardProgress,
    DapProjectEmptyPage
  }
})
export default class DapProjectsPage extends Vue {
  @Prop()
  projectId: number;

  @Prop({ required: false, default: false })
  public reloadProjects: boolean;

  @Getter(GET_LOADING)
  isLoading: boolean;

  @Watch('reloadProjects')
  public reload() {
    if (this.reloadProjects) {
      this.requestData();
      this.reloadProjects = false;
    }
  }

  public Size = Size;
  public searchInput: string = '';
  public searchValue$: string;
  public DapType = DapType;
  public parseDateToString = dateService.parseDateToString;
  public activeType: number = 1;
  public projectTypeDataSource: any[] = [{ text: 'DAP SUBMETIDOS', value: 3 }];
  private projects: IProject[] = [];
  public openConfiramation: boolean = false;
  public projectIdDelete: number = 0;

  public get projectsView() {
    return _(this.projects)
      .filter((p: IProject) => (this.activeType === 3 && p.dateSubmitApproval !== null) || (this.activeType === p.idProjectType && !p.dateSubmitApproval))
      .filter((p: IProject) =>
        _.size(this.searchValue$)
          ? stringService.normalize(p.name).includes(stringService.normalize(this.searchValue$))
          : true
      )
      .orderBy((p: IProject) => -p.id)
      .value();
  }

  public gotToCreateProject() {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_CREATE
    });
  }

  public gotToFlow() {
    this.$router.push({
      name: DAP_ROUTES.SUBMITTED_PROJECTS_RETAIL
    });
  }

  private cancelModalConfirmation() {
    this.openConfiramation = false;
  }

  private ConfirmModal() {
    this.openConfiramation = false;
    if (this.projectIdDelete != 0) {
      this.$router.push({
        name: DAP_ROUTES.PROJECT_EMPTY
      });

      const projects = this.projects.filter((p: IProject) => p.id !== this.projectIdDelete);
      this.projects = [];

      httpService.http
        .delete(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectIdDelete}`)
        .then((res: AxiosResponse) => {
          this.projects = projects;
        })
        .catch((err: AxiosError) => console.log(err.message));
    }
  }

  public deleteProject(projectId: number) {
    this.openConfiramation = true;
    this.projectIdDelete = projectId;
  }

  public gotToEditProject(projectId: string) {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_EDIT,
      params: { projectId }
    });
  }

  public gotToCreateDap(projectId: string, dapType: DapType) {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_CONFIGURATION,
      params: { projectId },
      query: { wizardStep: '3', dapType: String(dapType) }
    });
  }

  public gotToEditStores(projectId: string) {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_STORES,
      params: { projectId },
      query: { wizardStep: '1' }
    });
  }

  public gotToSubProject(projectId: string) {
    this.$router.push({
      name: DAP_ROUTES.PROJECT,
      params: { projectId }
    });
  }

  public created() {
    traceLogAccess.generationTracking(PageContextName.dap);
    this.requestData();
  }

  private requestData() {
    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/projectTypes`)
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        res[0].data.forEach((d: IProject) => {
          d.createdAt = new Date(d.createdAt as any);
        });
        this.projects = res[0].data;

        this.projectTypeDataSource = this.projectTypeDataSource.concat(res[1].data);
        this.projectTypeDataSource = _(this.projectTypeDataSource)
          .uniqBy('value')
          .orderBy('value')
          .value();

        if (this.projectId) {
          const activeProject = _.find(this.projects, (p: IProject) => p.id === this.projectId) as any;
          if (activeProject) {
            this.activeType = _.find(
              this.projectTypeDataSource,
              (p: any) => p.value === activeProject.idProjectType
            ).value;
          }
        } else {
          this.activeType = this.projectTypeDataSource[0].value;
        }
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
